import { Component } from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: true,
    templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    // UNIVAPLAT-3028: defaults match the directive's defaults, in case this
    // component is ever opened directly rather than via ConfirmDialogDirective.
    confirmOkClass = 'btn-danger';
    confirmCancelClass = 'btn-secondary';
    cancelFirst = false;
    // UNIVAPLAT-3499: opt-in header/description split. When set, `header` is the dialog title and
    // `title` is shown as the description in the body (default off: title is the header).
    header?: string;
    constructor(public modal: NgbActiveModal) {}
}
